import React, { useEffect, useState } from 'react';
import { makeStyles } from "@material-ui/core";
import clsx from 'clsx';
import FlagstoneTheme from '../../Config/flagstoneTheme';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ArrowDropUpIcon from '@material-ui/icons/ArrowDropUp';
import { useLocation, useHistory } from 'react-router-dom';
import { dataService } from '../../Services/data.service'
import { scissorTypes, scissorStates } from '../../Config/scissorStates'
import { productionOrderStates as state } from '../../Config/productionOrderStates'
import { toast } from 'react-toastify';
import { configureZonesByProductionOrderLines } from '../../Helpers/OrderInfoHelper';

export default function SelectedWorkstation(props) {
    const classes = useStyles();
    let history = useHistory();
    let location = useLocation();

    const [usedZones, setUsedZones] = useState([])
    const [showZones, setShowZones] = useState([false])
    const [upperScissorStatus, setUpperScissorStatus] = useState(null)
    const [lowerScissorStatus, setLowerScissorStatus] = useState(null)
    const [tableStatus, setTableStatus] = useState(null)

    useEffect(() => {
        dataService.getMachinesWithScissorStatusInfo().then(workstationsWithScissorStatusses => {

            let workstation = workstationsWithScissorStatusses.find(x => x.id === props.workstation.selectedWorkstation)
            let upperStatus = workstation.scissorStatuses.find(x => x.scissorName === scissorTypes.UPPER)
            let lowerStatus = workstation.scissorStatuses.find(x => x.scissorName === scissorTypes.LOWER)
            let tableStatus = workstation.scissorStatuses.find(x => x.scissorName === scissorTypes.TABLE)

            setUpperScissorStatus(upperStatus)

            setLowerScissorStatus(lowerStatus)

            setTableStatus(tableStatus)

        }).catch((error) => { toast.error(error, { position: "top-center" }) })

        dataService.getProductionOrdersByMachine(props.workstation.selectedWorkstation).then(orders => {

            orders = orders.filter(o => o.productionOrderStatus === state.PLANNED || o.productionOrderStatus === state.PAUSED || o.productionOrderStatus === state.RUNNING)

            let zones = configureZonesByProductionOrderLines(orders, props.zones)

            zones = zones.filter(x => x.used)

            if (zones.length > 0) {
                setShowZones(true)
            }
            setUsedZones(zones)

        }).catch((error) => { toast.error(error, { position: "top-center" }) })
        // eslint-disable-next-line
    }, [props.workstation.selectedZone]);


    const changeZone = (zone) => {
        let orderId = usedZones.find(x => x.zone === zone).orderId
        let orderLineId = usedZones.find(x => x.zone === zone).orderLineId
        if (location.pathname.includes('qualitychecks')) {

            dataService.getOrderDetailsByOrderId(orderId).then(productionOrder => {
                dataService.getProductionOrderLineBOMOutProducedByBOMOutId(productionOrder.bomOut[0].id).then(bomOutProduced => {
                    let progress = Math.ceil(bomOutProduced.quantityProduced / productionOrder.bomOut[0].quantityOnCarrier)
                    history.push('/qualitychecks/' + progress + '/' + orderId + '/' + orderLineId);
                    props.actions.setSelectedZone(zone)
                }).catch((error) => { toast.error(error, { position: "top-center" }) })

            }).catch((error) => { toast.error(error, { position: "top-center" }) })

        }
        else {
            history.push('/order/' + orderId + '/' + orderLineId)
            props.actions.setSelectedZone(zone)
        }
    }

    function getZoneColor(zone) {
        if (upperScissorStatus && lowerScissorStatus) {


            if (usedZones.find(x => x.zone === zone.zone).scissor === 1) {
                if (upperScissorStatus.name === scissorStates.SCRAP) {
                    return "#D84949";
                }
            }
            else {

                if (lowerScissorStatus.name === scissorStates.SCRAP) {
                    return "#D84949"
                }
            }
        } else if (tableStatus) {
            if (tableStatus.name === scissorStates.SCRAP) {
                return "#D84949"
            }
        }

        if (zone.zone === props.workstation.selectedZone) {
            return "#4654FB"
        }
        else {
            return "#000000"
        }
    }

    return <React.Fragment>
        {showZones && usedZones.length > 0 ?
            <div className={classes.selectedLineContainer}>
                <div className={classes.selectedLineInnerContainer}>
                    <button className={classes.selectedLine} key={props.line}>{props.line}</button>
                    {usedZones.map(z => {
                        return (
                            <button className={classes.selectedZoneButton} onClick={() => changeZone(z.zone)} key={z.zone}>
                                {upperScissorStatus &&
                                    <div className={classes.topScissor}>
                                        {z.scissor === 1 ? <ArrowDropUpIcon className={classes.topScissorIcon}></ArrowDropUpIcon> : <React.Fragment></React.Fragment>}
                                    </div>
                                }
                                <div style={{ color: getZoneColor(z) }} className={clsx({ [classes.zoneSelected]: props.workstation.selectedZone === z.zone, [classes.zoneNotSelected]: props.workstation.selectedZone !== z.zone })}> {z.zone}</div>

                                {lowerScissorStatus &&
                                    <div className={classes.bottomScissor}>
                                        {z.scissor === 0 ? <ArrowDropDownIcon className={classes.bottomScissorIcon}></ArrowDropDownIcon> : <React.Fragment></React.Fragment>}
                                    </div>
                                }
                            </button>)
                    }
                    )}
                </div>
            </div>
            : <button className={classes.selectedLineNoZones} key={props.id}>{props.line}</button>
        }
    </React.Fragment >
}

const useStyles = makeStyles({
    selectedLine: {
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: "bold",
        color: "#4654FB",
        backgroundColor: "#E6E8FE",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        outline: "none",
        border: "1px solid white",
        borderRadius: "50%",
        width: "30px",
        height: "30px",
    },
    selectedLineNoZones: {
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: "bold",
        color: "#4654FB",
        backgroundColor: "#E6E8FE",
        display: "inline-block",
        outline: "none",
        border: "1px solid white",
        borderRadius: "50%",
        width: "30px",
        height: "30px",
    },
    selectedZoneButton: {
        position: "relative",
        display: "inline",
        height: "30px",
        border: "none",
        outline: "none",
        cursor: "pointer",
        backgroundColor: "rgb(1,1,1,0)"
    },
    selectedLineContainer: {
        display: "flex",
        alignItems: "center",
        height: "32px",
        borderRadius: "16px",
        backgroundColor: "white"
    },
    selectedLineInnerContainer: {
        display: "flex",
        alignItems: "center",
    },
    zoneSelected: {
        height: "28px",
        width: "28px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        borderRadius: "50%",
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: "bold",
        backgroundColor: "#E6E8FE",
        boxSizing: "border-box"
    },
    zoneNotSelected: {
        height: "28px",
        width: "28px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        borderRadius: "50%",
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: "bold",
        backgroundColor: "white",
        paddingTop: "2px",
        boxSizing: "border-box",
    },
    topScissor: {
        position: "absolute",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: "1",
        color: FlagstoneTheme.palette.primary.main,
        left: "50%",
        transform: "translateX(-50%)",
    },
    topScissorIcon: {
        position: "relative",
        bottom: "8px",
        height: "20px",
        width: "20px",
        zIndex: "1",
        color: FlagstoneTheme.palette.primary.main,
    },
    bottomScissor: {
        position: "absolute",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: "1",
        color: FlagstoneTheme.palette.primary.main,
        left: "50%",
        transform: "translateX(-50%)",
        bottom: "-5px",
    },
    bottomScissorIcon: {
        position: "relative",
        height: "20px",
        width: "20px",
        zIndex: "1",
        color: FlagstoneTheme.palette.primary.main,
    },


});